import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Adyl itto",
  title: "Hi, I'm Adyl",
  subTitle: emoji(
    "A curious passionate Full Stack Software Developer 🚀 having an experience not only of building Web and Mobile applications with JavaScript / Reactjs / Nodejs / React Native and some other cool libraries and frameworks, but also pionnering in blockchain projects development with safety & security."
  ),
  resumeLink:
    "", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/adylitto",
  linkedin: "https://www.linkedin.com/in/adylitto/",
  gmail: "adylitto@gmail.com",
  gitlab: "https://gitlab.com/adylitto",
  medium: "https://medium.com/@adylitto",
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "swift",
      fontAwesomeClassname: "fab fa-swift"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
	{
      skillName: "Linux",
      fontAwesomeClassname: "fab fa-linux"
    },
	{
      skillName: "ethereum",
      fontAwesomeClassname: "fab fa-ethereum"
    },
	{
      skillName: "rust",
      fontAwesomeClassname: "fab fa-rust"
    },
	{
      skillName: "Git",
      fontAwesomeClassname: "fab fa-github"
    },
	{
      skillName: "MOTOKO",
      fontAwesomeClassname: "fab fa-ethereum"
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Dapp University",
      logo: require("./assets/images/dapp-logo-500x500.png"),
      subHeader: "Blockchain developper",
      duration: "September 2019 - now",
      desc: "Ethereum solidity programming -smart contract - arbitrage bot",
      descBullets: [
        "DeFi and smart contracts",
        "Crosschain Arbitrage bots"
      ]
    },
     {
      schoolName: "Carnegie Mellon University",
      logo: require("./assets/images/cmulogo-500x500.png"),
      subHeader: "Security offsec",
      duration: "2019 - now",
      desc: "Pentesting and some other cool safe stuff! :)",
      descBullets: [
        "Kali suite",
        "Network security"
      ]
    },
	{
      schoolName: "Paris University",
      logo: require("./assets/images/UniParis_logo.webp"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "September 1994 - April 1999",
      desc: "Took courses about Software Engineering, Web Security, Operating Systems, ...",
      descBullets: ["Machine Learning"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "80%"
    },
    {
      Stack: "UI/UX Design",
      progressPercentage: "90%"
    }
  ],
  displayCodersrank: true // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "DLT developper",
      company: "Dfinity.org",
      companylogo: require("./assets/images/DFINITY-Internet-Computer-logo-770x565-1-768x564.webp"),
      date: "June 2021 – Present",
      desc: "Scaled e-commerce dropshipping platform ",
      descBullets: [
        "Marketing",
        "custom programming"
      ]
    },
	{
      role: "Web developper",
      company: "BH Empire",
      companylogo: require("./assets/images/bhempire.webp"),
      date: "July 2019 – March 2021",
      desc: "Scaled e-commerce dropshipping platform ",
      descBullets: [
        "E-commerce Marketing",
        "custom programming"
      ]
    },
    {
      role: "Full stack developer Intern",
      company: "Realise",
      companylogo: require("./assets/images/realise-500x500.png"),
      date: "may 2018 – juin 2019",
      desc: ""
    },
    {
      role: "Entrepreneur - ride hailing App business Developement",
      company: "Swissdriver",
      companylogo: require("./assets/images/SwissDriver-500x500.png"),
      date: "May 2013 – july 2018",
      desc: ""
    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: true, // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: " Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    
    {
      image: require("./assets/images/LOGO-kmk-500x500px.png"),
      projectName: "KryptoManiaK",
      projectDesc: "Crypto blog covering news and education guides on major concerns about new DLT",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://kryptomaniak.com/"
        }
      ]
    },
    {
      image: require("./assets/images/logo.krypto-500x500.png"),
      projectName: "Krypt",
      projectDesc: "This project demonstrates a basic Hardhat use case. It comes with a sample contract, a test for that contract, a sample script that deploys that contract, and an example of a task implementation, which simply lists the available accounts.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://krypto-maestro.vercel.app/"
        },
		{
          name: "code",
          url: "https://github.com/Adylitto/KryptoMaestro"
        }
      ]
    },
    {
      image: require("./assets/images/logo-dwitter-500x500px.png"),
      projectName: "Dwitter",
      projectDesc: "A decentralised Twitter-like app runnig on Polygon Matic testnet Mumbai chain",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://twitter-start-one.vercel.app/"
        },
		{
          name: "code",
          url: "https://github.com/Adylitto/Twitter-Start"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "Selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "false", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://kryptomaniak.com/",
      title: "Crypto blogging",
      description:
        "Learn and stay updated of the Crypto Sphere"
    },
    {
      url: "https://adylitto.com",
      title: "Why is Mindset important?",
      description:
        "My mindset Blog to keep on grit"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest 2019",
      slides_url: "",
      event_url: ""
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/adyli"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "I'd be more than happy to discuss a project or just want to say hi? My Inbox is open for all.",
  email_address: "adylitto@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "KRYPTOMANIAK_", 
  display: true 
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
